import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "640",
  height: "784",
  fill: "none",
  "aria-hidden": "true"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("pattern", {
    id: "a",
    width: "20",
    height: "20",
    x: "118",
    y: "0",
    patternUnits: "userSpaceOnUse"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      fill: "currentColor",
      d: "M0 0h4v4H0z",
      class: "_text-gray-200"
    })
  ])
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", { d: "M0 72h640v640H0z" }, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "url(#a)",
  d: "M118 0h404v784H118z"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }